import { __assign } from "tslib";
import React from 'react';
import { components } from 'react-select';
import SelectClearIcon from '@atlaskit/icon/glyph/select-clear';
export { ClearIndicator, DropdownIndicator, LoadingIndicator, } from './indicators';
export var MultiValueRemove = function (props) { return (React.createElement(components.MultiValueRemove, __assign({}, props),
    React.createElement(SelectClearIcon, { label: "Clear", size: "small", primaryColor: "transparent", secondaryColor: "inherit" }))); };
export var IndicatorSeparator = null;
//# sourceMappingURL=index.js.map